import { writable } from 'svelte/store';

export const url = writable('https://app.kastratisolar.de'); // http://localhost:3000 https://test.jjprojects.de 